<script setup lang="ts">
import ContentBlocks from '@/components/content-blocks/ContentBlocks.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';
import ContentContainer from '@/components/layout/ContentContainer.vue';
import { useVisibleAnchor } from '@/composables/useVisibleAnchor';
import type { SectionData } from '@/types';

defineProps<{
  pageData: SectionData[];
}>();

const { vTrackAnchorTarget } = useVisibleAnchor();
</script>

<template>
  <div>
    <section
      v-for="({ title, blocks, link }, idx) in pageData"
      :id="link?.anchor"
      :key="idx"
      v-track-anchor-target
      class="section"
    >
      <ContentContainer>
        <ContentColumn>
          <h2>{{ title }}</h2>
        </ContentColumn>
      </ContentContainer>
      <ContentBlocks :blocks="blocks" />
    </section>
  </div>
</template>

<style lang="scss" scoped>
.section {
  margin-bottom: var(--spacing-xl);
}
</style>
